"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../../hooks");
const useStyles = props => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isDisabled = false
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccTaskManagerSectionLabelStyle = (0, _react.useMemo)(() => {
    const ccTaskManagerSectionLabel = (0, _css.css)({
      color: themeColors?.general.text,
      lineHeight: 1.4,
      marginBottom: pxToRem(4),
      padding: `0 ${pxToRem(14)}`,
      flex: 'none',
      fontWeight: 'bold',
      width: isMobileView ? 'auto' : '90%',
      span: {
        fontSize: pxToRem(isMobileView ? 16 : 14)
      }
    });
    const ccTaskManagerSectionLabelText = (0, _css.css)({
      opacity: isDisabled ? 0.7 : 1
    });
    const ccTaskManagerSectionLabelMessage = (0, _css.css)({
      color: themeColors?.general.alert,
      padding: `0 ${pxToRem(4)}`
    });
    return {
      ccTaskManagerSectionLabel,
      ccTaskManagerSectionLabelText,
      ccTaskManagerSectionLabelMessage
    };
  }, [isDisabled, isMobileView, pxToRem, themeColors?.general.alert, themeColors?.general.text]);
  return {
    'cc-TaskManager__section-label': ccTaskManagerSectionLabelStyle.ccTaskManagerSectionLabel,
    'cc-TaskManager__section-label__text': ccTaskManagerSectionLabelStyle.ccTaskManagerSectionLabelText,
    'cc-TaskManager__section-label__message': ccTaskManagerSectionLabelStyle.ccTaskManagerSectionLabelMessage
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;